.lockIcon {
  margin-bottom: var(--spacing-md);
}
